import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { ReactNode, useEffect, useState } from 'react'
import Card from './Card'
import { useCopyToClipboard } from '../hooks/useCopyToClipboard'

interface Props {
  value?: string
  disabledValue?: string
  disabledNotice?: ReactNode
  emptyNotice?: ReactNode
  tooltipContent: ReactNode
  onCopiedChange?: (copied?: string) => void
  className?: string
  cardClassName?: string
}

const CopyableApiKeyValue = ({
  value,
  disabledValue,
  disabledNotice,
  emptyNotice = <span className='opacity-50'>-</span>,
  tooltipContent,
  onCopiedChange,
  className = 'w-full my-2',
  cardClassName = 'w-full break-all py-2 px-3',
}: Props) => {
  const [open, setOpen] = useState(false)
  const { copied, copyToClipboard } = useCopyToClipboard(
    (text: string) => !!text && text !== disabledValue,
  )
  const disabled = !value || value === disabledValue
  const showCopiedMessage = !!copied && copied === value

  useEffect(() => {
    onCopiedChange?.(copied)
  }, [copied, onCopiedChange])

  return (
    <Tooltip
      delayDuration={150}
      open={open || showCopiedMessage}
      onOpenChange={setOpen}
    >
      <TooltipContent>
        {showCopiedMessage ? 'Copied!' : tooltipContent}
      </TooltipContent>
      <TooltipTrigger
        disabled={disabled}
        type='button'
        className={`${className} ${
          disabled ? 'pointer-events-none' : 'pointer-events-auto'
        }`}
      >
        <Card
          onClick={() => copyToClipboard(value ?? '')}
          className={cardClassName}
        >
          {value === disabledValue ? disabledNotice : value ?? emptyNotice}
        </Card>
      </TooltipTrigger>
    </Tooltip>
  )
}

export default CopyableApiKeyValue
